import service from '@/services/GsEncuesta/ubigeo'

export default {
  UBIGEO_FIND_ALL_DEPARTAMENTO(_, params) {
    return new Promise((resolve, reject) => {
      service.findAllDepartamento(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  UBIGE_FIND_ALL_PROVINCIA(_, params) {
    return new Promise((resolve, reject) => {
      service.findProvinciaByDepartamento(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  UBIGE_FIND_ALL_DISTRITO(_, params) {
    return new Promise((resolve, reject) => {
      service.findDistritoByProvincia(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  UBIGE_FIND_ALL_CENTRO_POBLADO(_, params) {
    return new Promise((resolve, reject) => {
      service.findCentroPobladoByProvinciaByDistrito(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  UBIGEO_CREATE_ALL_CENTRO_POBLADO(_, params) {
    return new Promise((resolve, reject) => {
      service.createAllCentroPoblado(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
}
